import { useContext } from 'react';
import { Context, setUser as setUserAction } from './userProvider';

type User = Parameters<typeof setUserAction>[0];

export const useSetUser = () => {
    const { dispatch } = useContext(Context);
    return function setUser(user: User) {
        dispatch(setUserAction(user));
    };
};
